module.exports = __webpack_public_path__ + "assets/img/082580495608f3b1bccba6b339d217ab.png";